/* Autogenerated file. Do not modify */
define([], function() {
    'use strict';
    var skins = {};
     skins['skins.core.TwitterTweetSkin'] = {
  "react": [
    [
      "iframe",
      "iframe",
      [],
      {
        "allowtransparency": "true",
        "frameBorder": 0,
        "scrolling": "no",
        "allowFullScreen": true
      }
    ]
  ],
  "css": {}
}

    return skins;
});
